// 环境判断的唯一来源。
//
// 单独成文件而不是挂在 catalog.ts 里：request/domain.ts 这类底层模块也要用它，
// 让请求层去依赖业务商品目录（catalog.ts）属于分层倒置，也容易埋下循环依赖。
export const APP_ENV = import.meta.env.VITE_APP_ENV;

// 是否为开发环境
export const IS_DEV = APP_ENV === 'development';
